<template>
    <vx-card title="Редактирование домена" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название домена"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        disabled
                        v-model="form.sspTypeName"
                        autocomplete="off"
                        label="SSP"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveDomain()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
    import vSelect from 'vue-select';
    import axios from 'axios';

    export default {
        name: 'imagedomain-edit',   
        props: ['id'],
        data() {
            return {
                domain: undefined,
                form: {
                    name: undefined,
                    sspTypeName: undefined
                },
                errors: {
                    name: '',
                }
            }
        },
        components: {
            'v-select': vSelect
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.axios.get('imagedomains/' + this.id)
                    .then((domain) => {
                        this.domain = domain.data;
                        this.form.name = domain.data.name;
                        this.form.sspTypeName = domain.data.sspTypeName;
                    })
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка загрузки домена.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });
            },
            saveDomain() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                const params = Object.assign({}, this.form, { id: this.id });
                this.$axios({
                    method: 'PUT',
                    url: 'imagedomains/' + this.id,
                    params: params,
                    errors: this.errors,
                    success: (user) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Домен успешно обновлен",
                            color: "success",
                        });
                        this.$router.push('/imagedomains');
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при редактировании домена!",
                            color: "danger",
                        });
                    }
                })
            },
            cancelEdit() {
                this.$router.push('/imagedomains');
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style>
    .select-error > div {
        border: 1px solid rgba(var(--vs-danger),1)!important;
    }
</style>